import { queryOptions } from "@tanstack/react-query";
import { curatedCoworldName, frontDoorPath } from "../coworlds";
import { leagueRoute, slugifyLeagueName } from "../leagues";
import { buildBrowseLinks } from "./site-links";
import { navigationLeagues } from "./public-catalog";
import { recommendedGames } from "./recommended-games";

export function publicNavigationOptions() {
  return queryOptions({
    queryKey: ["site", "navigation", "public"],
    queryFn: async ({ signal }) => {
      const { featured, cards } = recommendedGames(
        await navigationLeagues({ signal }),
      );
      const leagues = featured ? [featured, ...cards] : [];
      return buildBrowseLinks(
        leagues.map((league) => ({
          title:
            curatedCoworldName(league.game.coworld_name ?? league.game.name) ??
            league.game.name,
          href: frontDoorPath({
            route: { game: leagueRoute(league).game },
            corpusSlug: slugifyLeagueName(
              league.game.coworld_name ?? league.game.name,
            ),
          }),
        })),
      );
    },
    staleTime: 60_000,
  });
}
